
export const formatMoney = currencyCode => amount => amount.toLocaleString('en-US', { style: 'currency', currency: currencyCode })




// WEBPACK FOOTER //
// ./src/Components/checkout/components/formatHelpers.js